import { Container, Row, Col } from "reactstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper";
// import Swiper and modules styles
import "swiper/css";
import "swiper/css/pagination";

import "./index.scss";
import ayse from "../../../../assets/images/shutterstock_2139568155.png";
import aa from "../../../../assets/images/aa.svg";

const UserCardsSection = () => {
  const comments = [
    {
      company_logo: "anadolu-isuzu",
      person: {
        name: "Bora izmirlioglu",
        title: "Manager Utility Services",
        comment:
          "Bu yılın en güzel etkinliklerinden biri oldu benim için. Dinamik, hayalleri yüksek gençlerle olmak çok güzel. İyi ki gelmişim :)",
      },
    },
    {
      company_logo: "beiersdorf",
      person: {
        name: "Nalan Yuzbasi",
        title: "Human Resources Business Partner",
        comment:
          "Career Plus ekibi bizi hiç şaşırtmıyor :). Etkinlik boyunca işinize işinize kattığınız değer ve gösterdiğiniz özveri takdire şayan! Seneye görüşmek üzere!",
      },
    },
    {
      company_logo: "bosch",
      person: {
        name: "Can Avcı",
        title: "Employer Branding&HR Communication Projects Expert",
        comment:
          "Sevgili 3İK Ekibi, bu sene de yine başarılı bir organizasyonda sizlerle olmak büyük mutluluk. Katılımcı öğrencilerin ilgisi, merakı, soruları, burada olmakla ne kadar doğru bir karar verdiğimizin göstergesi. Her etkinliğinizde bizlere gençlerle buluşma imkânı sunarak hem kendimizi anlatma hem de onların beklentilerini, bakış açılarını görme imkânı verdiğiniz için teşekkür ederiz. Tüm katılımcılara gelecek kariyerlerinde bol şans ve başarılar diliyoruz. Fikirlerini gerçeğe dönüştürebilmeleri dileklerimizle…",
      },
    },
    {
      company_logo: "cci",
      person: {
        name: "Semih Koseoglu",
        title: "Human Resources Business Partner",
        comment:
          "Sevgili Career Plus ekibi, öğrenciler ve şirketler arasında oluşturduğunuz köprü sayesinde her iki taraf için de değer yaratıyorsunuz. Bugün de keyifli ve verimli bir etkinlik geçirmemizi sağladınız. Sizi seviyoruz!",
      },
    },
    {
      company_logo: "cimsa",
      person: {
        name: "Melike Sucu",
        title: "Operation Leader",
        comment:
          "Başarılı ve keyifli bir organizasyon olduğunu düşünüyorum. Gençlerle birlikte olmak çok keyifli ve doyurucuydu.",
      },
    },
    {
      company_logo: "colgate",
      person: {
        name: "Sive Yilmaz",
        title: "Head of Talent Acquisition and Development Turkey&Isreal",
        comment:
          "Sevgili 3İK, 2015’te şahane bir yolculuğa birlikte adım attık ve oldukça sürdürülebilir bir şekilde maceraya her sene yeniliklerle ekleyerek devam ediyoruz. Sizlerle çalışmak çok keyifli ve öğretici. İyi ki varsınız. Sizi seviyoruz!",
      },
    },
    {
      company_logo: "danone",
      person: {
        name: "Cenk Kurt",
        title: "Specialized Nutrition Unit Lead",
        comment:
          "Çok güzel insanların olduğu, parlak zekaların bulunduğu bu etkinlikten harika enerji ile ayrılıyorum. Umarım buradaki her paylaşım bu zekaların yolculuğunda değer katan paylaşımlar olmuştur. Salonda bulunan her arkadaşımın yolculuğunda başarılı bir gelecek görüyorum. Bu platformu sağlayan ve emeği geçen herkese teşekkür ediyorum. Sevgilerimle...",
      },
    },
    {
      company_logo: "ford-otosan",
      person: {
        name: "Ali Riza Aksoy",
        title: "HR Leader",
        comment:
          "Career Plus organizasyonunda yer almaktan, şirketim ve şahsım adına çok büyük keyif aldım. Emeği geçenleri kutluyorum.",
      },
    },
    {
      company_logo: "mercedes-benz",
      person: {
        name: "Pelin Yurttas - Tugce Hekimoglu",
        title: "Human Resources Business Partner",
        comment:
          "Career Plus etkinliğinde bulunmaktan çok keyif aldık. Katıldığımız birçok kariyer etkinliklerine göre çok daha kalifiye ve bilinçli bir öğrenci profiliyle karşılaşmak bizi çok mutlu etti. Her şey için teşekkürler.",
      },
    },
    {
      company_logo: "migros",
      person: {
        name: "Omer Basar",
        title: "Head of IT",
        comment:
          "Sevgili 3İK Ekibi, hevesli, girişken ve teknolojiyi yakından takip eden 60 kişilik bir öğrenci topluluğu ile bizi buluşturduğunuz için çok teşekkür ederim.",
      },
    },
    {
      company_logo: "nestle",
      person: {
        name: "Petek Boyacigil Yazici",
        title: "Senior Marketing Manager",
        comment:
          "Öğrencilere kariyerlerinin başında böyle bir fırsatın tanınmasına aracı olmanız çok güzel. Keyifli ve fırsatlar yaratan bir program. Herkes için çok güzel geçsin!",
      },
    },
    {
      company_logo: "oyak-renault",
      person: {
        name: "Arda Kina",
        title: "Head of Learning&Development",
        comment:
          "Career Plus boyutundaki bu organizasyona katılmış olmak ve gençlerle vakit geçirmek gerçekten çok keyifliydi. Organizasyonda emeği geçen herkese teşekkürler.",
      },
    },
    {
      company_logo: "sisecam1",
      person: {
        name: "Ebru Kahraman",
        title: "Employer Branding Manager",
        comment:
          "Sevgili 3İK Ekibi, Gençlere böyle güzel imkân tanıdığınız için Şişecam ailesi adına çok teşekkür ederiz. Elinize ve emeğinize sağlık.",
      },
    },
    {
      company_logo: "turk-telekom",
      person: {
        name: "Mehtap Arzu Can",
        title: "Özel Çözümler Müdürü",
        comment:
          "Çok verimli ve keyifli bir zaman dilimiydi. Gençlerin enerjisi ve ilgileri muhteşemdi. İyi ki gelmişim :)",
      },
    },
    {
      company_logo: "unilever",
      person: {
        name: "Olcay Cat",
        title: "HR Manager,Supply Chain Non-Make&Procurement",
        comment:
          "Pek değerli 3İK ekibi ve Career Plus’ta destek veren tüm arkadaşlar, her zamanki samimiyetiniz ve profesyonelliğinizi bugün de gösterdiğiniz için; sonsuz desteğiniz ve güler yüzlülüğünüz için çok teşekkür ediyorum. Daha sonrakilerde görüşmek üzere!",
      },
    },
    {
      company_logo: "unilever",
      person: {
        name: "Hande Ottekin",
        title: "Brand Manager",
        comment:
          "Yaratıcı düşüncelere ve farklı yaklaşımlara belki de en çok ihtiyacı olan FMCG sektörü için çok önemli olan bu etkinliğe imza attığınız ve bizi öğrenciler ile bir araya getirdiğiniz için teşekkür ederiz. Başarılarınızın devamını dilerim. :)",
      },
    },
  ];

  return (
    <section className="user-card-section">
      <Container>
        <Swiper
          spaceBetween={30}
          pagination={{
            clickable: true,
          }}
          modules={[Pagination]}
          className="mySwiper"
        >
          {comments.map((c, index) => {
            return (
              <SwiperSlide key={index}>
                <Row>
                  <Col sm="12" md="12" lg="4">
                    <div className="user-image">
                      <img
                        src={require("../../../../assets/images/Career Plus-Logolar-300x300/" +
                          c.company_logo +
                          ".png")}
                        alt={c.company_logo}
                      />
                    </div>
                  </Col>
                  <Col
                    sm="12"
                    md="12"
                    lg="7"
                    xl="7"
                    className="position-relative"
                  >
                    <h2>{c.person.name}</h2>
                    <h4>{c.person.title}</h4>
                    <p>{c.person.comment}</p>
                    {/* <img className="aa" src={aa} alt="aa" /> */}
                    <p className="aa">’’</p>
                  </Col>
                </Row>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </Container>
    </section>
  );
};
export default UserCardsSection;
